// The product-page quantity minus button is a silent no-op once quantity is
// already at the minimum purchase increment (usually 1). Callers disable the
// button there so the tap is not an active-looking control that does nothing.

export function isQuantityDecrementDisabled(quantity, increment) {
	const step = Number(increment)
	const minimum = Number.isFinite(step) && step > 0 ? step : 1
	const qty = Number(quantity)
	if (!Number.isFinite(qty)) return true
	return qty <= minimum
}
